module.exports = __webpack_public_path__ + "statics/img/cate4-1@2x.56d20742.png";